import '@/css/desktop/atlas/landing-destinations-header.scss';

import Controller from '../common/SearchController';

$(() => {
    const searchController = new Controller({
        el: 'body',
    });
    searchController.initSearchOnScroll();
});
